import { IApi } from '../../api'
import { createRequestTypes } from '../../helpers/helpers'
import { createAction } from '../types'

export const prefix = 'generalLedger'

export const UPDATE_GENERAL_LEDGER_REQUEST = `${prefix}/UPDATE_GENERAL_LEDGER_REQUEST`
export const UPDATE_GENERAL_LEDGER_SUCCESS = `${prefix}/UPDATE_GENERAL_LEDGER_SUCCESS`
export const UPDATE_GENERAL_LEDGER_FAILURE = `${prefix}/UPDATE_GENERAL_LEDGER_FAILURE`

export const updateGeneralLedger = createAction((id: string, data: object | FormData) => ({
  type: [
    UPDATE_GENERAL_LEDGER_REQUEST,
    UPDATE_GENERAL_LEDGER_SUCCESS,
    UPDATE_GENERAL_LEDGER_FAILURE,
  ],
  promise: (api: IApi) => api.generalLedger.processGeneralLedger(id, data),
}))

export const LIST_TYPES_REQUEST = `${prefix}/LIST_TYPES_REQUEST`
export const LIST_TYPES_SUCCESS = `${prefix}/LIST_TYPES_SUCCESS`
export const LIST_TYPES_FAILURE = `${prefix}/LIST_TYPES_FAILURE`

export const listTypes = createAction(() => ({
  type: [LIST_TYPES_REQUEST, LIST_TYPES_SUCCESS, LIST_TYPES_FAILURE],
  promise: (api: IApi) => api.generalLedger.listTypes(),
}))

export const LIST_TYPE_MAPPING_REQUEST = `${prefix}/LIST_TYPE_MAPPING_REQUEST`
export const LIST_TYPE_MAPPING_SUCCESS = `${prefix}/LIST_TYPE_MAPPING_SUCCESS`
export const LIST_TYPE_MAPPING_FAILURE = `${prefix}/LIST_TYPE_MAPPING_FAILURE`

export const listTypeMapping = createAction((id: string, params: object = {}) => ({
  type: [LIST_TYPE_MAPPING_REQUEST, LIST_TYPE_MAPPING_SUCCESS, LIST_TYPE_MAPPING_FAILURE],
  promise: (api: IApi) => api.generalLedger.listTypeMapping(id, params),
  params,
}))

export const UPDATE_TYPE_MAPPING_REQUEST = `${prefix}/UPDATE_TYPE_MAPPING_REQUEST`
export const UPDATE_TYPE_MAPPING_SUCCESS = `${prefix}/UPDATE_TYPE_MAPPING_SUCCESS`
export const UPDATE_TYPE_MAPPING_FAILURE = `${prefix}/UPDATE_TYPE_MAPPING_FAILURE`

export const updateTypeMapping = createAction((id: string, data: object) => ({
  type: [UPDATE_TYPE_MAPPING_REQUEST, UPDATE_TYPE_MAPPING_SUCCESS, UPDATE_TYPE_MAPPING_FAILURE],
  promise: (api: IApi) => api.generalLedger.updateTypeMapping(id, data),
}))

export const HIDE_ALIASES = `${prefix}/HIDE_ALIASES`

export const hideAliases = () => ({
  type: HIDE_ALIASES,
})

export const HIDE_TYPE_MAPPING = `${prefix}/HIDE_TYPE_MAPPING`

export const hideTypeMapping = () => ({
  type: HIDE_TYPE_MAPPING,
})

export const LIST_DILUTION_OVER_TIME_REQUEST = `${prefix}/LIST_DILUTION_OVER_TIME_REQUEST`
export const LIST_DILUTION_OVER_TIME_SUCCESS = `${prefix}/LIST_DILUTION_OVER_TIME_SUCCESS`
export const LIST_DILUTION_OVER_TIME_FAILURE = `${prefix}/LIST_DILUTION_OVER_TIME_FAILURE`

export const listDilutionOverTime = createAction((id: string, params: object = {}) => ({
  type: [
    LIST_DILUTION_OVER_TIME_REQUEST,
    LIST_DILUTION_OVER_TIME_SUCCESS,
    LIST_DILUTION_OVER_TIME_FAILURE,
  ],
  promise: (api: IApi) => api.generalLedger.listDilutionOverTime(id, params),
  params,
}))

export const HIDE_DILUTION_OVER_TIME = `${prefix}/HIDE_DILUTION_OVER_TIME`

export const hideDilutionOverTime = () => ({
  type: HIDE_DILUTION_OVER_TIME,
})

const LIST_DILUTION_DROPDOWNS = createRequestTypes(prefix, `/LIST_DILUTION_DROPDOWNS`)

export const [
  LIST_DILUTION_DROPDOWNS_REQUEST,
  LIST_DILUTION_DROPDOWNS_SUCCESS,
  LIST_DILUTION_DROPDOWNS_FAILURE,
] = LIST_DILUTION_DROPDOWNS
export const listDilutionDropdowns = createAction((id: string, params: object = {}) => ({
  type: LIST_DILUTION_DROPDOWNS,
  promise: (api: IApi) => api.generalLedger.listDilutionDropdowns(id, params),
  params,
}))

export const HIDE_DILUTION_DROPDOWNS = `${prefix}/HIDE_DILUTION_DROPDOWNS`

export const hideDilutionDropdowns = () => ({
  type: HIDE_DILUTION_DROPDOWNS,
})

const LIST_WHOLESALE_DILUTION = createRequestTypes(prefix, `/LIST_WHOLESALE_DILUTION`)

export const [
  LIST_WHOLESALE_DILUTION_REQUEST,
  LIST_WHOLESALE_DILUTION_SUCCESS,
  LIST_WHOLESALE_DILUTION_FAILURE,
] = LIST_WHOLESALE_DILUTION
export const listWholesaleDilution = createAction((id: string, params: object = {}) => ({
  type: LIST_WHOLESALE_DILUTION,
  promise: (api: IApi) => api.generalLedger.listWholesaleDilution(id, params),
  params,
}))
